import React, { useState, useEffect } from 'react';
import { FormControl, Box } from '@material-ui/core';
import { PageLoader, PasslyInfiniteScroll, PasslyCheckbox, PasslyTextField } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import _ from 'lodash';
import { useDebounce } from '@app/helpers';

interface IProps {
    setHasMoreItems: Function;
    setValueFilter: Function;
    setHandleCheck: Function;
    setFilteredItems: Function;
    fetchMore: Function;
    selectAll?: boolean;
    filteredItems?: any;
    localItems?: any;
    nonMemberedItems?: any;
    noMoreResults?: string;
    totalCount?: number | undefined;
    additionalDisplayText?: string;
    hasMoreItems?: boolean;
    dataLoading?: boolean;
    orgs?: any;
    disableEdit?: boolean;
    isDisableToRemoveAoR?: boolean;
}

export const SelectIdentitiesComponent = (props: IProps) => {
    const { translation } = useTypedTranslation();

    const { selectAll, filteredItems, setHandleCheck, orgs, localItems, setFilteredItems, nonMemberedItems, noMoreResults, fetchMore, totalCount, setHasMoreItems,
        setValueFilter, additionalDisplayText, dataLoading, disableEdit, isDisableToRemoveAoR } = props;

    const [displayText, setDisplayText] = useState('');
    const [selectAllChecbox, setSelectAllChecbox] = useState(selectAll);

    const debouncedValue = useDebounce(displayText, 500);

    useEffect(() => {
        if (filteredItems.some((item: any) => item.checked === true)) {
            setHandleCheck(false);
        } else {
            setHandleCheck(true);
        }
    }, [filteredItems]);

    useEffect(() => {
        if (totalCount !== undefined && nonMemberedItems.length < totalCount) {
            setHasMoreItems(true);
        } else {
            setHasMoreItems(false);
        }
    }, [nonMemberedItems, totalCount]);

    useEffect(() => {
        if (debouncedValue) {
            setFilteredItems(localItems);
            setValueFilter(displayText);
        } else {
            setFilteredItems(localItems);
            setValueFilter(displayText);
            setDisplayText('');
        }
    }, [debouncedValue]);

    const resolveOrgName = (nonMemberedId: string): string => {
        if (nonMemberedId) {
            let org = _.find(orgs, { Id: nonMemberedId });
            if (org) {
                return org.Name;
            } else {
                org = _.find(orgs, { id: nonMemberedId });
                if (org) {
                    return org.name;
                }
            }
        }
        return '';
    };

    const handleFilteredList = (e: any) => {
        const value = e.target.value;
        setDisplayText(value);
    };

    const updateAllCheckboxes = (checked: boolean, e: any) => {
        if (filteredItems.length > 0) {
            setSelectAllChecbox(checked);
            let newRows = [...filteredItems];
            if (e.target) {
                newRows.forEach((newRow) => {
                    newRow.checked = checked;
                });
                setFilteredItems(newRows);
            }
        }
    };

    const onCheckboxChange = (index: number) => (checked: boolean, e: any) => {
        filteredItems.filter((a: any) => a.checked);

        if (filteredItems[index].id === e.target.name) {
            let newRows = [...filteredItems];
            newRows[index].checked = checked;
            setFilteredItems(newRows);
        }
    };

    const emailAndOrgDisplay = (item: any) => {
        const orgName: string = resolveOrgName(item.organizationId);

        if (orgName === '') {
            return item.emailAddress;
        }
        else {
            return item.emailAddress + ' | ' + orgName;
        }
    };

    return (
        <div className='modal__identities-list'>
            <div className='modal__identities-list--filter'>
                <FormControl>
                    <PasslyTextField fullWidth id='modal-identities-list-filter' label={'FILTER_BY'} value={displayText} onChange={handleFilteredList} showSearchIcon={true} autoFocus/>
                </FormControl>
                {!disableEdit && (
                    <PasslyCheckbox
                        name='selectAllIdentityCheckbox'
                        checked={selectAllChecbox || false}
                        onChange={updateAllCheckboxes}
                        label={translation('SELECT_ALL')}
                    />
                )}
            </div>
            <div className='modal__identities-list--data'>
                <PasslyInfiniteScroll totalCount={totalCount ?? 0} currentCount={filteredItems.length} onFetch={fetchMore}>
                    {filteredItems?.length > 0 ? filteredItems.map((item: any, index: number) => (
                        <div style={disableEdit ? { marginTop: '8px' } : {}} key={item.id}>
                            <div className='modal__identities-list--row'>
                                {!disableEdit && (
                                    <PasslyCheckbox
                                        name={item.id}
                                        checked={item.checked}
                                        onChange={onCheckboxChange(index)}
                                        label=''
                                        disabled={isDisableToRemoveAoR && item.isAccountOfRecord}

                                    />
                                )}
                                <Box ml={1}>{item.name}</Box>
                                {(additionalDisplayText === 'organizations' && (
                                        <div className='modal__identities-list--org'>
                                            {item.organizationId ? '(' + resolveOrgName(item.organizationId) + ')' : ''}
                                        </div>
                                    )) ||
                                    (additionalDisplayText === 'email-organization' && (
                                        <div className='modal__identities-list--org'>
                                            ({emailAndOrgDisplay(item)})
                                        </div>
                                    )) ||
                                    (additionalDisplayText === 'email' &&
                                      <div className='modal__identities-list--org'>({item.principalName})</div>)}
                            </div>
                        </div>
                    )) : dataLoading ? (
                        <PageLoader />
                    ) : (
                                <p className='modal__identities-list--no-data'>{noMoreResults}</p>
                            )}
                </PasslyInfiniteScroll>
            </div>
        </div>
    );
};
